module.exports = __webpack_public_path__ + "static/serverless-icon-d41e8cb2313c181e75f476fc049a2b1a.png";